import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY, RANGES } from "../../data/products";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[var(--forest)] text-[var(--bone)] grain overflow-hidden">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 pt-20 pb-10">
      <p className="font-display text-4xl sm:text-5xl lg:text-7xl font-light leading-[1.02] max-w-4xl">
        Intake drives <em className="text-[#8DC63F]">performance.</em>
      </p>
      <div className="mt-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-4 space-y-5">
          <Logo light />
          <p className="text-[#C9D6C8] text-sm leading-relaxed max-w-xs">
            Feed palatability, aquaculture and poultry performance solutions — formulated and manufactured in India.
          </p>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow text-[#9FBF9C] mb-5">Product ranges</p>
          <ul className="space-y-3">
            {RANGES.map((r) => (
              <li key={r.slug}>
                <Link to={`/products/${r.slug}`} data-testid={`footer-link-${r.slug}`} className="link-underline">{r.name}</Link>
                <span className="text-[#AFC2AE] text-sm"> — {r.species}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-5">
          <p className="eyebrow text-[#9FBF9C] mb-5">Head office</p>
          <ul className="space-y-3 text-[15px] text-[#E4EBE1]">
            <li className="flex gap-3"><MapPin size={18} className="shrink-0 mt-0.5 text-[#8DC63F]" />{COMPANY.address}</li>
            <li className="flex gap-3"><Phone size={18} className="shrink-0 mt-0.5 text-[#8DC63F]" /><a data-testid="footer-phone" href={COMPANY.phoneHref} className="link-underline">{COMPANY.phone}</a></li>
            <li className="flex gap-3"><Mail size={18} className="shrink-0 mt-0.5 text-[#8DC63F]" /><a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="link-underline">{COMPANY.email}</a></li>
            <li className="flex gap-3"><Globe size={18} className="shrink-0 mt-0.5 text-[#8DC63F]" />{COMPANY.website}</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-6 border-t border-white/15 flex flex-col sm:flex-row gap-3 justify-between text-xs text-[#AFC2AE]">
        <span>© {new Date().getFullYear()} {COMPANY.name} All rights reserved. For animal feed use only.</span>
        <span className="font-mono">Made in India · Noida · Aurangabad</span>
      </div>
    </div>
  </footer>
);
